
<div class="container hide-scrollbar">
  <br /> 
  <h1>High Alloy and Nonferrous Steel</h1>
  <br/>
  <div style="margin-top: 10px;">
    <form [formGroup] ="highalloyform" (ngSubmit)="onSubmit()" class="form-horizontal">
        <div class="row form-group" >
          <div class="col-md-6">
            <div class ="row">
              <div class="col-md-12">
                <img *ngIf="this.intUnit === 0" src= '/assets/images/HighAlloyandNonferrousSteelsBGinches.PNG' class="center-block img-thumbnail"/>
                <img *ngIf="this.intUnit === 1" src= '/assets/images/HighAlloyandNonferrousSteelsBGmm.PNG' class="center-block img-thumbnail"/>
              </div>
            </div>
            <div class ="row">
              <div class="col-md-12">
                <br />
                <button typ="button" id="Bid2"  name="nBtn2" class="btn btn-primary btn-custom no-arrow" (click)="closeDialog()"><span class="icon-chevron-left"></span>&nbsp;Back</button>
              </div>
            </div>
          </div>
          <div class="col-md-3">
           
            <div class ="row">
                <div class="col-md-12">
                    <label  class="control-label">Maximum Operating Temperature, Top &nbsp;<span *ngIf="this.intUnit === 0">(&#8457;)</span>
                    <span *ngIf="this.intUnit === 1">(&#8451;)</span>
                    </label>     
                </div>
            </div>
            <br />
            <!-- <br /> -->
            <div class ="row">
              <div class="col-md-12">
                <label  class="control-label">Pipe Nominal size, NPS &nbsp;<span *ngIf="this.intUnit === 0">(inch)</span><span *ngIf="this.intUnit === 1">(mm)</span>
                </label> 
              </div>
              
            </div>
           
            <div class ="row">
              <div class="col-md-12">
                <br />
                <br />
                <p style="color: {{myColor}};">{{ Result }}</p>

                <!-- Supplemental Loads question when Type A screening fails -->
                <div *ngIf="typaResult === false && showSupplementalLoadsQuestion" style="margin-top: 10px;">
                  <label class="control-label"><b>Supplemental loads are available</b></label>
                  <div style="margin-top: 5px;">
                    <mat-radio-group [(ngModel)]="supplementalLoadsSelection" [ngModelOptions]="{standalone: true}">
                      <mat-radio-button value="yes" style="margin-right: 15px;">Yes</mat-radio-button>
                      <mat-radio-button value="no">No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div *ngIf="supplementalValidationMessage" style="color: red; margin-top: 5px; font-size: 12px;">{{ supplementalValidationMessage }}</div>
                </div>

               </div>
            </div>
            
          </div>
          <div class="col-md-3">
            <div class ="row">
              <div class="col-md-12">
                <input  formControlName ="input1" class=" form-control border-secondary"  type="number" required autofocus/>
              </div>
            </div>
            <br />
            <div class ="row">
              <div class="col-md-12">
                <input formControlName ="input2" class="form-control border-secondary"  type="number" required/>
              </div>
            </div>
            <div class ="row float-right">
              <div class="col-md-12">
                <br />
                <br />
                <br />
                <br />
                <button class="btn btn-primary btn-custom no-arrow"  id="Bid1" name="nBtn1"  type="submit" (click)="onSubmit()">Calculate&nbsp;<span class="icon-chevron-right"></span></button>
              </div>
            </div>
            <div class ="row float-right">             
              <div class="col-md-12" >               
                <br />
                <div style="margin-top:120px"></div>
                <button  typ="button"id="Bid3"  name="nBtn3" class="btn btn-primary btn-custom no-arrow" [disabled]="isDisabled" (click)="BacktoALS()">Next&nbsp;<span class="icon-chevron-right"></span></button>  
                </div>
            </div>
          </div>         
        </div>          
      </form>    
  </div>

</div>

   
